import { ESignInStep } from '../models/ESignInStep';
import type { SignInPhoneStepController } from './phone-step/SignInPhoneStepController';
import type { SignInCodeStepController } from './code-step/SignInCodeStepController';
import type { SignInProfileFillingStepController } from './profile-filling-step/SignInProfileFillingStepController';
import type { IPopup } from '@mm-frontend/mm-web-ui-kit';
import type { SignInBlockedStepController } from './blocked-step/SignInBlockedStepController';

export class SignInController {
  private step: ESignInStep = ESignInStep.Phone;

  private phoneStepController: SignInPhoneStepController;
  private codeStepController: SignInCodeStepController;
  private fillingProfileStepController: SignInProfileFillingStepController;
  private blockedStepController: SignInBlockedStepController;

  constructor({
    phoneStepController,
    codeStepController,
    fillingProfileStepController,
    blockedStepController,
  }: {
    phoneStepController: SignInPhoneStepController;
    codeStepController: SignInCodeStepController;
    fillingProfileStepController: SignInProfileFillingStepController;
    blockedStepController: SignInBlockedStepController;
  }) {
    this.phoneStepController = phoneStepController;
    this.codeStepController = codeStepController; 
    this.fillingProfileStepController = fillingProfileStepController;
    this.blockedStepController = blockedStepController;
  }

  private openCurrentStepPopup() {
    switch (this.step) {
      case ESignInStep.Phone:
        this.phoneStepController.popup?.show();
        break;
      case ESignInStep.Code:
        this.codeStepController.popup?.show();
        break;
      case ESignInStep.FillingProfile:
        this.fillingProfileStepController.popup?.show();
        break;
      case ESignInStep.Blocked:
        this.blockedStepController.popup?.show();
        break;
    }
  }

  private closeCurrentStepPopup() {
    switch (this.step) {
      case ESignInStep.Phone:
        this.phoneStepController.popup?.close();
        break;
      case ESignInStep.Code:
        this.codeStepController.popup?.close();
        break;
      case ESignInStep.FillingProfile:
        this.fillingProfileStepController.popup?.close();
        break;
      case ESignInStep.Blocked:
        this.blockedStepController.popup?.close();
        break;
    }
  }

  public openSignInPopup() {
    this.openCurrentStepPopup();
  }

  public closeSignInPopup() {
    this.closeCurrentStepPopup();
  }

  private changeStep(step: ESignInStep) {
    this.closeCurrentStepPopup();
    this.step = step;
    this.openCurrentStepPopup();
  }

  public get isPhoneStep() {
    return this.step === ESignInStep.Phone;
  }

  public goToPhoneStep() {
    this.changeStep(ESignInStep.Phone);
  }

  public get isCodeStep() {
    return this.step === ESignInStep.Code;
  }

  public goToCodeStep() {
    this.changeStep(ESignInStep.Code);
  }

  public get isFillingProfileStep() {
    return this.step === ESignInStep.FillingProfile;
  }

  public goToFillingProfileStep() {
    this.changeStep(ESignInStep.FillingProfile);
  }

  public get isBlockedStep() {
    return this.step === ESignInStep.Blocked;
  }

  public goToBlockedStep() {
    this.changeStep(ESignInStep.Blocked);
  }

  public resetStep() {
    this.step = ESignInStep.Phone
  }
}
